import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useStatisticsQueries from '@dashboard/hooks/queries/useStatisticsQueries';
import { useStatisticsContext } from './Dashboard';
import { statisticKey } from '@dashboard/lib/queryKeys';

export function useStatistics(metric) {
  const { dateStart, dateEnd, unit, timezoneOffset } = useStatisticsContext();

  const { sellerId } = useAuth();

  const { getStatistics } = useStatisticsQueries();

  const { data, isError, isLoading } = useQuery({
    queryKey: statisticKey({
      metric,
      sellerId,
      dateStart,
      dateEnd,
      unit,
      timezoneOffset,
    }),
    queryFn: () => getStatistics({ metric, dateStart, dateEnd, unit, timezoneOffset }),
    staleTime: 1000 * 60, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    enabled: !!sellerId,
  });

  return {
    isLoading,
    isError,
    data,
  };
}
